import TableCellText from "ds/components/Table/Row/CellText";

import IntentProjectEnvironmentMountedFilesTableCell from "../Cell";
import { IntentProjectEnvironmentMountedFilesTableCellContentProps } from "../types";

const IntentProjectEnvironmentMountedFilesTableSecretCell = ({
  item: variable,
  ...cellProps
}: IntentProjectEnvironmentMountedFilesTableCellContentProps) => {
  const isSecret = variable.writeOnly;

  return (
    <IntentProjectEnvironmentMountedFilesTableCell {...cellProps}>
      <TableCellText>{isSecret ? "Secret" : "Plain"}</TableCellText>
    </IntentProjectEnvironmentMountedFilesTableCell>
  );
};

export default IntentProjectEnvironmentMountedFilesTableSecretCell;
